export const isLetterFirst = (text: string): boolean => /^\p{L}{1}/u.test(text)
